import { useState, useEffect } from "react";
// ★U8(cmd-po_1109): sip-stepper共通部品
import { SipStepper } from "../common/SipStepper";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  FormHelperText,
  MenuItem,
  IconButton,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// cmd-po_1247: 未使用の CloseIcon import を退役
import CheckIcon from "@mui/icons-material/Check";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EmailIcon from "@mui/icons-material/Email";

// QRコード生成
import { QRCodeCanvas } from "qrcode.react";

// InterFace
import { useWindowSize } from "../../lib/useWindowSize";

// API
import {
  getContractProduct,
  postContract,
  postContractShortMessage,
} from "../../api/contract";
import { getAddress } from "../../api/address";
import {
  getPresignedPostPicture,
  postPresignedPost,
} from "../../api/presignedURL";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";

// ★ cmd-po_1137: po-form 共通部品
import { PoField, PoLabel, PoTextField, PoSelect, PoCheckbox, PoHelper, PoSplit, PoCheckGroup, PoCheckRow, PoFileDrop, PO_FORM_MSG, isValidMail, isValidTel, isValidZip } from "../common/PoForm";
// ★ cmd-po_1147: 外殻共通部品 + PoButton 乗せ替え
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

interface InputFreeTextProps {
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "confirm"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    phone_number: string;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "confirm"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "sms_success";
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      productId: number | null;
      productName: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      phone_number: string;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOption: { [key: string]: string | number | string[] };
  addressOptionName: string;
}

function InputFreeText(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextHalfWidthNumber(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          const inputValue = e.target.value;
          if (!/^\d*$/.test(inputValue)) return;
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = inputValue;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        inputProps={{ inputMode: "numeric", pattern: "\\d*" }}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      const phone_number = input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        phone_number,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => { const v=e.target.value; if(/^\d*$/.test(v)) setInput1(v); }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => { const v=e.target.value; if(/^\d*$/.test(v)) setInput2(v); }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => { const v=e.target.value; if(/^\d*$/.test(v)) setInput3(v); }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextFormTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => { const v=e.target.value; if(/^\d*$/.test(v)) setInput1(v); }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => { const v=e.target.value; if(/^\d*$/.test(v)) setInput2(v); }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => { const v=e.target.value; if(/^\d*$/.test(v)) setInput3(v); }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      const customer_name = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customer_name,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField id="textFieldIdName1" value={input1} onChange={async (e) => setInput1(e.target.value)} />
        <PoTextField id="textFieldIdName2" value={input2} onChange={async (e) => setInput2(e.target.value)} />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextCompanyName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          const customer_company_name = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            customer_company_name,
          }));
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextZipCode(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidZip(`${input1}-${input2}`);
  useEffect(() => {
    async function getAddressText(zipCode: string) {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = zipCode;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));

      const address = await getAddress(zipCode);
      customerInfo[addressOptionName] = address;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const zipCode = input1 + "-" + input2;
      if (input1.length === 3 && input2.length === 4) {
        getAddressText(zipCode);
      } else {
        let customerInfo = addData.customerInfo;
        customerInfo[uniqueOption.option_name as string] = zipCode;
        setAddData((addData) => ({
          ...addData,
          customerInfo,
        }));
      }
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdZipCode1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          inputProps={{ maxLength: 3 }}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 3) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdZipCode2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          inputProps={{ maxLength: 4 }}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 4) {
              setInput2(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextSpace(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField id="textFieldIdSpace1" value={input1} onChange={async (e) => setInput1(e.target.value)} />
        <PoTextField id="textFieldIdSpace2" value={input2} onChange={async (e) => setInput2(e.target.value)} />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextMailAddress(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidMail(`${input1}@${input2}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("@");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + "@" + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdmm1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <Box sx={{ flex: "0 0 auto" }}>@</Box>
        <PoTextField
          id="textFieldIdmm2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

interface ContractCopyEntryModalProps {
  entryToEntryDataInf: {
    addStatus: string;
    contractId: string;
    changeAccount: number;
    changeAccountID: number | null;
    productId: number | null;
    contractData: any[];
    entryProductList: any[];
    beforeOptionData: any[];
    optionData: any[];
    outSiteEntry: 0 | 1;
    site_path: string;
    outsideMessageType: number | null;
    smsMessagePatternID: number | null;
  };
  setEntryToEntryDataInf: React.Dispatch<React.SetStateAction<any>>;
  closeEntryToEntryModal: () => void;
  customerInfo: { [key: string]: string | string[] };
  setCustomerInfo: React.Dispatch<
    React.SetStateAction<{ [key: string]: string | string[] }>
  >;
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "confirm"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "confirm"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "sms_success";
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      productId: number | null;
      productName: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      phone_number: string;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  addressOptionName: string;
  setAddressOptionName: React.Dispatch<React.SetStateAction<string>>;
  selectServisePlanList: { service_name: string }[];
  setSelectServisePlanList: (value: { service_name: string }[]) => void;
  selectServiseContentList: { service_name: string }[];
  setSelectServiseContentList: (value: { service_name: string }[]) => void;
  selectServiseCampaignPulldownList: { service_name: string }[];
  setSelectServiseCampaignPulldownList: (
    value: { service_name: string }[],
  ) => void;
  selectServiseCampaignCheckboxList: { service_name: string }[];
  setSelectServiseCampaignCheckboxList: (
    value: { service_name: string }[],
  ) => void;
  selectServisePaymentList: { payment_method: string }[];
  setSelectServisePaymentList: (value: { payment_method: string }[]) => void;
  uniqueOptinList: { [key: string]: string | number | string[] }[];
  setUniqueOptinList: (
    value: { [key: string]: string | number | string[] }[],
  ) => void;
  postPictures: { [key: string]: File };
  setPostPictures: React.Dispatch<
    React.SetStateAction<{ [key: string]: File }>
  >;
  onPostButton: boolean;
  setOnPostButton: React.Dispatch<React.SetStateAction<boolean>>;
  selectedProductId: number | null;
  setSelectedProductId: React.Dispatch<React.SetStateAction<number | null>>;
  selectedProductName: string;
  setSelectedProductName: React.Dispatch<React.SetStateAction<string>>;
  setOnDataAddModalResult: React.Dispatch<React.SetStateAction<string>>;
  accountCollaborateCompanySaleList?: {
    sale_company_id: number;
    sale_company_name: string;
    id: number;
    account_name: string;
  }[];
  // ★cmd-po_1209 F1: 複製success後の一覧refetch（親 getTableData(true) を発火する経路）
  reloadList: () => void;
}

export function ContractCopyEntryModal(props: ContractCopyEntryModalProps) {
  const {
    entryToEntryDataInf,
    setEntryToEntryDataInf,
    closeEntryToEntryModal,
    addData,
    setAddData,
    addressOptionName,
    setAddressOptionName,
    selectServisePlanList,
    setSelectServisePlanList,
    selectServiseContentList,
    setSelectServiseContentList,
    selectServiseCampaignPulldownList,
    setSelectServiseCampaignPulldownList,
    selectServiseCampaignCheckboxList,
    setSelectServiseCampaignCheckboxList,
    selectServisePaymentList,
    setSelectServisePaymentList,
    uniqueOptinList,
    setUniqueOptinList,
    postPictures,
    setPostPictures,
    setOnDataAddModalResult,
    accountCollaborateCompanySaleList,
    reloadList,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // stp-acct chip用 担当者名 — ContractAdd:1176-1183 コピペ移植(cmd-po_1109j)
  const acctName = (() => {
    if (addData.changeAccount === 1 && addData.changeAccountID !== null) {
      return (accountCollaborateCompanySaleList ?? []).find(
        (x) => x.id === addData.changeAccountID
      )?.account_name ?? "";
    }
    return loginUser?.username ?? "";
  })();

  // --- Sync parent addStatus → internal addData ---
  useEffect(() => {
    const parentStatus = entryToEntryDataInf.addStatus;
    if (parentStatus === "product") {
      // cmd-po_1147: CAC next → CCEM open 時は confirm 面を初期面とする
      setAddData((prev) => ({
        ...prev,
        addStatus: "confirm",
        changeAccount: entryToEntryDataInf.changeAccount as 0 | 1,
        changeAccountID: entryToEntryDataInf.changeAccountID,
      }));
    } else if (parentStatus === "" || parentStatus === "loading") {
      // Reset internal state when parent closes or loading
      if (parentStatus === "") {
        setAddData((prev) => ({ ...prev, addStatus: null }));
      }
    }
  }, [entryToEntryDataInf.addStatus]);


  // 商材一覧検索用 (uses entryProductList from parent)
  const contractProductList = (entryToEntryDataInf.entryProductList || []).map(
    (p: any) => ({
      id: p.product_id,
      product_name: p.product_name,
      have_entry_form: p.have_entry_form,
      site_path_list: p.site_path_list || [],
    }),
  );
  const [inputSerchProductName, setInputSerchProductName] = useState("");
  const [serchProductList, setSerchProductList] = useState<
    {
      id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[]
  >([]);
  useEffect(() => {
    if (inputSerchProductName === "") {
      const serchProductList = contractProductList.filter(
        (product: any) =>
          product.have_entry_form === 1 || product.site_path_list.length > 0,
      );
      setSerchProductList(serchProductList);
    } else {
      const serchProductList = contractProductList.filter(
        (product: any) =>
          (product.have_entry_form === 1 ||
            product.site_path_list.length > 0) &&
          product.product_name.includes(inputSerchProductName),
      );
      setSerchProductList(serchProductList);
    }
  }, [entryToEntryDataInf.entryProductList, inputSerchProductName]);

  // 外部ET用の変数
  const [outSidePullDownServiceNameList, setOutSidePullDownServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [outSideCheckBoxServiceNameList, setOutSideCheckBoxServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [smsMessagePatterns, setSmsMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_body: string;
    }[]
  >([]);
  const [mailMessagePatterns, setMailMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_title: string;
      outside_sms_body: string;
    }[]
  >([]);

  const [useMailAddressFlg, setUseMailAddressFlg] = useState(false);
  const [postPicturesError, setPostPicturesError] = useState<{[key: string]: string}>({});

  // --- 顧客情報プリフィル: 元エントリーのcustomerInfoを新商材のoption_dataにマッピング ---
  function applyCustomerInfoPrefill(
    newOptionData: any[],
    customerInfoDefaults: { [key: string]: string | string[] },
  ): { [key: string]: string | string[] } {
    const beforeOptionData: any[] = entryToEntryDataInf.beforeOptionData ?? [];
    const sourceCustomerInfo =
      entryToEntryDataInf.contractData?.[0]?.customer_info ?? {};
    if (
      Object.keys(sourceCustomerInfo).length === 0 ||
      beforeOptionData.length === 0
    ) {
      return customerInfoDefaults;
    }

    // Collect flag-based field name mappings from beforeOptionData
    let tel_flg_option_name = "";
    let name_flg_option_name = "";
    let company_name_flg_option_name = "";
    let zip_code_flg_option_name = "";
    let address_flg_option_name = "";
    let mail_address_flg_option_name = "";
    beforeOptionData.forEach((before_option: any) => {
      if (before_option.tel_flg === 1)
        tel_flg_option_name = before_option.option_name;
      if (before_option.name_flg === 1)
        name_flg_option_name = before_option.option_name;
      if (before_option.company_name_flg === 1)
        company_name_flg_option_name = before_option.option_name;
      if (before_option.zip_code_flg === 1)
        zip_code_flg_option_name = before_option.option_name;
      if (before_option.address_flg === 1)
        address_flg_option_name = before_option.option_name;
      if (before_option.mail_address_flg === 1)
        mail_address_flg_option_name = before_option.option_name;
    });

    const result = { ...customerInfoDefaults };

    newOptionData.forEach((option: any) => {
      const optionName = option.option_name as string;
      if (option.change_value_conf === 1) return;

      if (option.option_type === 0) {
        // Level 1: Exact name match
        beforeOptionData.forEach((before_option: any) => {
          if (
            before_option.option_name === optionName &&
            before_option.option_type === 0
          ) {
            if (optionName in sourceCustomerInfo) {
              result[optionName] = sourceCustomerInfo[optionName];
            }
          }
        });
        // Level 2: Flag-based match (overrides exact name match for semantic fields)
        if (option.tel_flg === 1 && tel_flg_option_name !== "") {
          result[optionName] =
            sourceCustomerInfo[tel_flg_option_name] ?? result[optionName];
        }
        if (option.name_flg === 1 && name_flg_option_name !== "") {
          result[optionName] =
            sourceCustomerInfo[name_flg_option_name] ?? result[optionName];
        }
        if (
          option.company_name_flg === 1 &&
          company_name_flg_option_name !== ""
        ) {
          result[optionName] =
            sourceCustomerInfo[company_name_flg_option_name] ??
            result[optionName];
        }
        if (option.zip_code_flg === 1 && zip_code_flg_option_name !== "") {
          result[optionName] =
            sourceCustomerInfo[zip_code_flg_option_name] ?? result[optionName];
        }
        if (option.address_flg === 1 && address_flg_option_name !== "") {
          result[optionName] =
            sourceCustomerInfo[address_flg_option_name] ?? result[optionName];
        }
        if (
          option.mail_address_flg === 1 &&
          mail_address_flg_option_name !== ""
        ) {
          result[optionName] =
            sourceCustomerInfo[mail_address_flg_option_name] ??
            result[optionName];
        }
      } else if (option.option_type === 1) {
        // Select: exact name match + validate value exists in new options
        beforeOptionData.forEach((before_option: any) => {
          if (
            before_option.option_name === optionName &&
            before_option.option_type === 1
          ) {
            const srcVal = sourceCustomerInfo[optionName] as string;
            if (srcVal && (option.option_select as string[]).includes(srcVal)) {
              result[optionName] = srcVal;
            }
          }
        });
      } else if (option.option_type === 2) {
        // Checkbox: exact name match + filter valid values
        beforeOptionData.forEach((before_option: any) => {
          if (
            before_option.option_name === optionName &&
            before_option.option_type === 2
          ) {
            const srcVals = sourceCustomerInfo[optionName] as string[];
            if (Array.isArray(srcVals)) {
              const validVals = srcVals.filter((v: string) =>
                (option.option_select as string[]).includes(v),
              );
              if (validVals.length > 0) {
                result[optionName] = validVals;
              }
            }
          }
        });
      } else if (option.option_type === 3) {
        // Date: exact name match
        beforeOptionData.forEach((before_option: any) => {
          if (
            before_option.option_name === optionName &&
            before_option.option_type === 3
          ) {
            if (optionName in sourceCustomerInfo) {
              result[optionName] = sourceCustomerInfo[optionName];
            }
          }
        });
      }
      // option_type === 4 (image): no inheritance
    });

    return result;
  }

  async function getProductInfo(
    productId: number,
    productName: string,
    outSiteEntry: 0 | 1,
    site_path: string,
  ) {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    setEntryToEntryDataInf((prev: any) => ({ ...prev, addStatus: "loading" }));
    const {
      service_plan_data,
      service_content_data,
      service_campaign_pulldown_data,
      service_campaign_checkbox_data,
      service_payment_data,
      option_data,
      outside_pull_down_service,
      outside_check_box_service,
      outside_option_data,
      outside_sms_patterns,
      outside_mail_patterns,
    } = await getContractProduct(
      productId,
      outSiteEntry,
      site_path,
      addData.changeAccount,
      addData.changeAccountID,
    );
    if (outSiteEntry === 0) {
      // 内部エントリー
      if (service_plan_data.length === 0) {
        closeEntryToEntryModal();
        setOnDataAddModalResult(
          "エントリー可能なプランが定義されていません。管理者に問い合わせてください。",
        );
      } else {
        setSelectServisePlanList(service_plan_data);
        setSelectServiseContentList(service_content_data);
        if (service_campaign_pulldown_data.length > 0) {
          setSelectServiseCampaignPulldownList([
            { service_name: "" },
            ...service_campaign_pulldown_data,
          ]);
        } else {
          setSelectServiseCampaignPulldownList(service_campaign_pulldown_data);
        }
        setSelectServiseCampaignCheckboxList(service_campaign_checkbox_data);
        setSelectServisePaymentList(service_payment_data);
        setUniqueOptinList(option_data);
        if (option_data.length > 0) {
          // Build default customerInfo (same as ContractAddModal)
          const customerInfoDefaults: {
            [key: string]: string | string[];
          } = option_data.reduce<{ [key: string]: string | string[] }>(
            (column, option) => {
              let option_value: string | string[] = "";
              if (option.option_type === 0) {
                option_value = option.option_default_value as string;
                return {
                  ...column,
                  [option.option_name as string]: option_value,
                };
              } else if (option.option_type === 1 || option.option_type === 4) {
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              } else if (option.option_type === 3) {
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              } else {
                return {
                  ...column,
                  [option.option_name as string]: [],
                };
              }
            },
            {},
          );
          // Apply pre-fill from original entry's customerInfo
          const customerInfo = applyCustomerInfoPrefill(
            option_data,
            customerInfoDefaults,
          );
          let localAddressOptionName = "";
          option_data.map((uniqueOptin: any) => {
            if (uniqueOptin.address_flg) {
              localAddressOptionName = uniqueOptin.option_name as string;
            }
          });
          setAddressOptionName(localAddressOptionName);
          setAddressOptionName(localAddressOptionName);
          setEntryToEntryDataInf((prev: any) => ({
            ...prev,
            addStatus: "contract",
            outSiteEntry,
          }));
          const sourceContractData =
            entryToEntryDataInf.contractData?.[0] ?? {};
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            addStatus: "contract",
            productId,
            productName,
            outSiteEntry,
            phone_number: sourceContractData.customer_phone_number ?? "",
            customer_name: sourceContractData.customer_name ?? "",
            customer_company_name:
              sourceContractData.customer_company_name ?? "",
            serviseCustomerListID:
              sourceContractData.customer_list_id != null
                ? String(sourceContractData.customer_list_id)
                : "",
          }));
        } else {
          closeEntryToEntryModal();
          setOnDataAddModalResult(
            "エントリーフォームが定義されていません。管理者に問い合わせてください。",
          );
        }
      }
    } else if (outSiteEntry === 1) {
      // 外部エントリー
      setOutSidePullDownServiceNameList(outside_pull_down_service);
      setOutSideCheckBoxServiceNameList(outside_check_box_service);
      setSmsMessagePatterns(outside_sms_patterns);
      setMailMessagePatterns(outside_mail_patterns);
      if (outside_option_data.length > 0) {
        const customerInfoDefaults: {
          [key: string]: string | string[];
        } = outside_option_data.reduce<{ [key: string]: string | string[] }>(
          (column, option) => {
            let option_value: string | string[] = "";
            if (option.option_type === 0) {
              option_value = option.option_default_value as string;
              return {
                ...column,
                [option.option_name as string]: option_value,
              };
            } else if (option.option_type === 1 || option.option_type === 4) {
              return {
                ...column,
                [option.option_name as string]: "",
              };
            } else if (option.option_type === 3) {
              return {
                ...column,
                [option.option_name as string]: "",
              };
            } else {
              return {
                ...column,
                [option.option_name as string]: [],
              };
            }
          },
          {},
        );
        // Apply pre-fill from original entry's customerInfo
        const customerInfo = applyCustomerInfoPrefill(
          outside_option_data,
          customerInfoDefaults,
        );
        let localAddressOptionName = "";
        let mail_address_flg_use = false;
        outside_option_data.map((uniqueOptin: any) => {
          if (uniqueOptin.address_flg) {
            localAddressOptionName = uniqueOptin.option_name as string;
          }
          if (uniqueOptin.mail_address_flg_use) {
            mail_address_flg_use = true;
          }
        });
        setUseMailAddressFlg(mail_address_flg_use);
        setUniqueOptinList(outside_option_data);
        setAddressOptionName(localAddressOptionName);
        setAddressOptionName(localAddressOptionName);
        setEntryToEntryDataInf((prev: any) => ({
          ...prev,
          addStatus: "contract",
          outSiteEntry,
          site_path,
        }));
        const sourceContractData2 = entryToEntryDataInf.contractData?.[0] ?? {};
        setAddData((addData) => ({
          ...addData,
          customerInfo,
          addStatus: "contract",
          productId,
          productName,
          site_path,
          outSiteEntry,
          phone_number: sourceContractData2.customer_phone_number ?? "",
          customer_name: sourceContractData2.customer_name ?? "",
          customer_company_name:
            sourceContractData2.customer_company_name ?? "",
          serviseCustomerListID:
            sourceContractData2.customer_list_id != null
              ? String(sourceContractData2.customer_list_id)
              : "",
        }));
      } else {
        closeEntryToEntryModal();
        setOnDataAddModalResult(
          "外部ETフォームが定義されていません。管理者に問い合わせてください。",
        );
      }
    }
  }

  const [onPostBottun, setOnPostBottun] = useState(false);
  useEffect(() => {
    if (addData.addStatus !== null && addData.addStatus !== "loading") {
      let onPostBottun = true;
      // 内部エントリーの時のみ依存関係確認
      if (addData.outSiteEntry == 0) {
        uniqueOptinList.map((uniqueOptin) => {
          const service_plan_names =
            (uniqueOptin.service_plan_names as string[]) || [];
          const service_content_names =
            (uniqueOptin.service_content_names as string[]) || [];
          const depend_option_name =
            (uniqueOptin.depend_option_name as string) || "他質問に依存しない";
          const depend_select_names =
            (uniqueOptin.depend_select_names as string[]) || [];
          const depend_option_value = addData.customerInfo[depend_option_name];
          if (
            uniqueOptin.required_optional === 1 &&
            (service_plan_names.length === 0 ||
              service_plan_names.includes(addData.servicePlanName)) &&
            (service_content_names.length === 0 ||
              service_content_names.some((item) =>
                addData.serviceContentNameList.includes(item),
              )) &&
            (depend_option_name === "他質問に依存しない" ||
              (typeof depend_option_value === "string" &&
                depend_select_names.includes(depend_option_value as string)) ||
              (typeof depend_option_value === "object" &&
                depend_select_names.some((item) =>
                  depend_option_value.includes(item),
                )))
          ) {
            if (
              uniqueOptin.option_type === 0 ||
              uniqueOptin.option_type === 1 ||
              uniqueOptin.option_type === 3
            ) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
              if (
                customerInfoValue === undefined ||
                customerInfoValue === "" ||
                customerInfoValue === " " ||
                customerInfoValue === "--"
              ) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 2) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string[];
              if (customerInfoValue.length === 0) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 4) {
              if (!postPictures[uniqueOptin.option_name as string]) {
                onPostBottun = false;
              }
            }
          }
        });

        if (addData.servicePlanName === "") {
          onPostBottun = false;
        }
        if (
          selectServisePaymentList.length > 0 &&
          addData.servicePaymentMethodName === ""
        ) {
          onPostBottun = false;
        }
      }

      // 外部ETフォーム
      if (addData.outSiteEntry == 1) {
        // SMS送信情報確認
        if (addData.outsideMessageType === null) {
          onPostBottun = false;
        }
        if (
          (addData.outsideMessageType === 0 ||
            addData.outsideMessageType === 1) &&
          addData.smsMessagePatternID === null
        ) {
          onPostBottun = false;
        }

        // SMS送信の場合は顧客電話番号の確認
        if (addData.outsideMessageType === 0) {
          if (addData.phone_number === "--") {
            onPostBottun = false;
          }
        }

        // メール送信の場合はメールアドレスの確認
        if (addData.outsideMessageType === 1) {
          let mail_address = "@";
          // そもそも質問にメールアドレスが定義されていない場合
          if (useMailAddressFlg === false) {
            mail_address = addData.customerInfo["メールアドレス"] as string;
          }
          uniqueOptinList.map((uniqueOptin) => {
            if (uniqueOptin.mail_address_flg === 1) {
              mail_address = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
            }
          });
          if (mail_address === "@") {
            onPostBottun = false;
          }
        }
      }

      setOnPostBottun(onPostBottun);
    }
  }, [addData, postPictures]);

  // 契約登録前に画像データ格納
  async function postAddContractData() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    setEntryToEntryDataInf((prev: any) => ({ ...prev, addStatus: "loading" }));
    let customerInfo = { ...addData.customerInfo };
    const results = await Promise.all(
      uniqueOptinList.map(async (uniqueOption) => {
        if (
          uniqueOption.option_type === 4 &&
          postPictures[uniqueOption.option_name as string]
        ) {
          const postPicture = postPictures[uniqueOption.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", postPicture);
          // ファイルをS3にアップロード（S3受理確認）
          const r = await postPresignedPost(presigned_object.url, formData);
          if (r === "seccess") {
            customerInfo[uniqueOption.option_name as string] = destination_key;
          }
          return r;
        }
        return "seccess";
      }),
    );
    if (results.some((r) => r !== "seccess")) {
      const errMap: {[key: string]: string} = {};
      uniqueOptinList.forEach((opt, i) => {
        if (results[i] !== "seccess") {
          errMap[opt.option_name as string] = "画像のアップロードに失敗しました。もう一度お試しください。";
        }
      });
      setPostPicturesError(errMap);
      setAddData((prev) => ({ ...prev, addStatus: "contract" }));
      setEntryToEntryDataInf((prev: any) => ({ ...prev, addStatus: "contract" }));
      setOnDataAddModalResult("画像のアップロードに失敗しました。もう一度お試しください");
      return;
    }
    props.setSelectedProductName(addData.productName);

    if (addData.outSiteEntry === 0) {
      // 内部ET: postContract
      const postResponce = await postContract({ ...addData, customerInfo });
      if (postResponce === "success") {
        // ★cmd-po_1209 F1: 複製success後の一覧refetch回帰修正（登録 postAddData の getTableData(true) と同型・親へreloadList prop経由で発火。cmd-po_1197 step3移設で親側の旧refetch関数がdead化しrefetch黙殺していた回帰の是正）
        reloadList();
        closeEntryToEntryModal();
        setOnDataAddModalResult("success");
      } else {
        setOnDataAddModalResult(postResponce);
        setAddData((prev) => ({
          ...prev,
          addStatus: "contract",
        }));
        setEntryToEntryDataInf((prev: any) => ({
          ...prev,
          addStatus: "contract",
        }));
      }
    } else if (addData.outSiteEntry === 1) {
      // 外部ET: postContractShortMessage → sms_success(QRコード表示)
      let mail_address = "@";
      uniqueOptinList.map((uniqueOptin) => {
        if (uniqueOptin.mail_address_flg === 1) {
          mail_address = addData.customerInfo[
            uniqueOptin.option_name as string
          ] as string;
        }
      });
      if (mail_address === "@" && customerInfo["メールアドレス"]) {
        mail_address = customerInfo["メールアドレス"] as string;
      }

      const {
        postResponce,
        outsideSiteUrl,
        outsideServiceUrl,
        viewOutsideServiceUrl,
      } = await postContractShortMessage(
        { ...addData, customerInfo },
        mail_address,
        "",
        "",
      );
      if (postResponce === "success") {
        setAddData((prev) => ({
          ...prev,
          addStatus: "sms_success",
          outsideSiteUrl,
          outsideServiceUrl,
          viewOutsideServiceUrl,
        }));
      } else {
        setOnDataAddModalResult(postResponce);
        setAddData((prev) => ({
          ...prev,
          addStatus: "contract",
        }));
        setEntryToEntryDataInf((prev: any) => ({
          ...prev,
          addStatus: "contract",
        }));
      }
    }
  }

  return addData.addStatus !== null && addData.addStatus !== "loading" ? (
    // cmd-po_1147: PoModalShell 外殻乗せ替え + confirm 面新設
    <PoModalShell
      open={true}
      title="エントリー複製"
      onClose={closeEntryToEntryModal}
      testidPrefix="contract-copy-entry"
      frameTestId="contract-copy-entry-modal"
      widthPx={addData.addStatus === "confirm" ? 520 : 680}
      footer={
        addData.addStatus === "confirm" ? (
          <>
            <PoButton variant="secondary" data-testid="contract-copy-entry-confirm-cancel" onClick={closeEntryToEntryModal}>キャンセル</PoButton>
            <PoButton variant="primary" data-testid="contract-copy-entry-confirm-next" onClick={() => setAddData((p) => ({ ...p, addStatus: "product" }))}>エントリー作成へ</PoButton>
          </>
        ) : addData.addStatus === "product" ? (
          <PoButton variant="secondary" data-testid="contract-copy-entry-product-close" onClick={closeEntryToEntryModal}>戻る</PoButton>
        ) : addData.addStatus === "entry_method" ? (
          <PoButton variant="secondary" data-testid="contract-copy-entry-method-back" onClick={() => setAddData((p) => ({ ...p, addStatus: "product" }))}>戻る</PoButton>
        ) : addData.addStatus === "site_path" ? (
          <PoButton variant="secondary" data-testid="contract-copy-entry-site-path-back" onClick={() => setAddData((p) => ({ ...p, addStatus: "entry_method" }))}>戻る</PoButton>
        ) : addData.addStatus === "contract" ? (
          <>
            <PoButton
              variant="secondary"
              data-testid="contract-copy-entry-contract-back"
              onClick={() => {
                setAddData((addData) => ({
                  ...addData,
                  addStatus: "product",
                  productId: null,
                  productName: "",
                  have_entry_form: null,
                  servicePlanName: "",
                  serviceContentNameList: [],
                  serviceCampaignPulldownName: "",
                  serviceCampaignCheckboxName: [],
                  servicePaymentMethodName: "",
                  serviseCustomerListID: "",
                  pullDownServiceName: "",
                  checkBoxServiceNames: "",
                  smsMessagePatternID: null,
                  customerInfo: {},
                }));
                setSelectServisePlanList([]);
                setSelectServiseContentList([]);
                setSelectServiseCampaignPulldownList([]);
                setSelectServiseCampaignCheckboxList([]);
                setSelectServisePaymentList([]);
                setUniqueOptinList([]);
                setAddressOptionName("");
                setOutSidePullDownServiceNameList([]);
                setOutSideCheckBoxServiceNameList([]);
                setSmsMessagePatterns([]);
                setMailMessagePatterns([]);
                setUseMailAddressFlg(false);
              }}
            >
              戻る
            </PoButton>
            <PoButton
              variant="primary"
              data-testid="contract-copy-entry-submit"
              disabled={!onPostBottun}
              onClick={postAddContractData}
            >
              {addData.outSiteEntry === 0
                ? "新規登録"
                : addData.outsideMessageType === null || addData.outsideMessageType === 0
                  ? "SMS送信"
                  : addData.outsideMessageType === 1
                    ? "メール送信"
                    : addData.outsideMessageType === 2
                      ? "QRコード表示"
                      : "SMS送信"}
              {addData.outSiteEntry === 0 ? (
                <AddCircleOutlineIcon sx={{ marginLeft: "6px" }} fontSize="medium" />
              ) : (
                <EmailIcon sx={{ marginLeft: "6px" }} fontSize="medium" />
              )}
            </PoButton>
          </>
        ) : addData.addStatus === "sms_success" ? (
          <>
            <PoButton variant="secondary" data-testid="contract-copy-entry-success-back" onClick={() => setAddData((p) => ({ ...p, addStatus: "contract" }))}>入力に戻る</PoButton>
            <PoButton variant="primary" data-testid="contract-copy-entry-success-close" onClick={closeEntryToEntryModal}>閉じる</PoButton>
          </>
        ) : null
      }
      beforeBody={
        // cmd-po_1211(D2-a): body child だった SipStepper を beforeBody slot(header直後・非スクロール帯=登録系ContractAdd:1419型)へ移設し stepper消失復旧。confirm面(進行step外=cmd-po_1147初期面)のみ非表示を現行維持。change_account抑制は撤廃し activeIndex に change_account→0 を追加。
        addData.addStatus !== "confirm" ? (
          <SipStepper
            steps={["担当アカウント", "商材選択", "情報入力"]}
            activeIndex={addData.addStatus === "change_account" ? 0 : addData.addStatus === "product" ? 1 : 2}
            suffix={
              acctName ? (
                <Box data-testid="ccem-stp-acct" sx={{ fontSize: 11, fontWeight: 600, color: "var(--color-ai, #1e3a5f)", bgcolor: "var(--color-ai-pale, #e8eef4)", borderRadius: "999px", px: 1.25, py: 0.375, flexShrink: 0, whiteSpace: "nowrap" }}>
                  担当: {acctName}
                </Box>
              ) : undefined
            }
          />
        ) : undefined
      }
    >
      {addData.addStatus === "confirm" ? (
          // cmd-po_1147: confirm 面（初期面）— mock default_pc に対応
          <>
            {(() => {
              const nameOpt = (entryToEntryDataInf.beforeOptionData ?? []).find((o: any) => o.name_flg === 1);
              const custName = nameOpt ? entryToEntryDataInf.contractData?.[0]?.customer_info?.[nameOpt.option_name] : undefined;
              return (
                <>
                  <Box
                    data-testid="contract-copy-entry-confirm-note"
                    sx={{ fontSize: "var(--fs-13)", color: "var(--color-sumi)", lineHeight: 1.7 }}
                  >
                    トスアップ{custName ? `（${custName}）` : ""}をエントリーへ転換します。以下の入力値をエントリー作成パネルへ引き継ぎます。
                  </Box>
                  <Box
                    component="table"
                    className="ce-table"
                    data-testid="contract-copy-entry-confirm-table"
                    sx={{
                      width: "100%",
                      borderCollapse: "collapse",
                      "& td": { fontSize: "var(--fs-13)", color: "var(--color-sumi)", padding: "var(--sp-2)", borderBottom: "1px solid var(--color-border-light)" },
                      "& td:first-of-type": { width: "40%", color: "var(--color-sumi-muted)", fontSize: "var(--fs-12)" },
                    }}
                  >
                    <tbody>
                      {(entryToEntryDataInf.beforeOptionData ?? [])
                        .filter((o: any) => o.option_type !== 4)
                        .filter((o: any) => {
                          const val = entryToEntryDataInf.contractData?.[0]?.customer_info?.[o.option_name];
                          return val !== undefined && val !== null && val !== "";
                        })
                        .map((o: any, idx: number) => (
                          <Box component="tr" key={idx} data-testid="contract-copy-entry-confirm-row">
                            <Box component="td">{o.option_name}</Box>
                            <Box component="td">{entryToEntryDataInf.contractData?.[0]?.customer_info?.[o.option_name]}</Box>
                          </Box>
                        ))}
                    </tbody>
                  </Box>
                  <PoHelper>※画像項目は引き継がれません。引き継いだ値は作成パネルで確認・編集できます。</PoHelper>
                </>
              );
            })()}
          </>
        ) : addData.addStatus === "product" ? (
          <>
            <Box >
              商材検索（部分一致）
              <Box key="searchProductName">
                <PoTextField
                  id="inputSerchProductName"
                  data-testid="contract-copy-entry-product-search"
                  value={inputSerchProductName}
                  onChange={async (e) => {
                    setInputSerchProductName(e.target.value);
                  }}
                  fullWidth
                />
              </Box>
            </Box>
            {/* cmd-po_1147: Typography退役・footer→PoModalShell footer へ */}
            <Paper elevation={0}>
            <Box key="shozai1">
              <Box
                key="shozaiClick"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {serchProductList.map((product, i) => {
                  return (
                    <PoButton
                      key={i}
                      variant="primary"
                      style={{
                        marginTop: "10px",
                        width:
                          windowWidth > 385
                            ? "calc(50% - 5px)"
                            : "calc(100% - 10px)",
                        marginLeft:
                          windowWidth > 385 && i % 2 !== 0 ? "10px" : "0",
                      }}
                      onClick={async () => {
                        const productId = product.id;
                        const productName = product.product_name;
                        const have_entry_form = product.have_entry_form;
                        const site_path_list = product.site_path_list || [];
                        if (
                          have_entry_form !== 1 &&
                          site_path_list.length === 0
                        ) {
                          // エントリーフォーム未定義 & 外部サイトなし → 何もしない
                          return;
                        }
                        if (site_path_list.length > 0) {
                          setAddData((addData) => ({
                            ...addData,
                            addStatus: "entry_method",
                            productId,
                            productName,
                            have_entry_form,
                            site_path_list,
                          }));
                        } else {
                          await getProductInfo(
                            productId,
                            productName,
                            0,
                            "",
                          );
                        }
                      }}
                    >
                      {product.product_name}
                    </PoButton>
                  );
                })}
              </Box>
            </Box>
          </Paper>
          </>
        ) : addData.addStatus === "entry_method" ? (
          // cmd-po_1147: Typography退役・footer→PoModalShell footer へ
          <Paper elevation={0}>
            <Box key="contract1">
              <Box
                key="shozaiClick"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                <PoButton
                  data-testid="contract-copy-entry-method-entry"
                  disabled={addData.have_entry_form === 0}
                  variant="primary"
                  style={{
                    marginTop: "10px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: "0px",
                  }}
                  onClick={async () => {
                    await getProductInfo(
                      addData.productId as number,
                      addData.productName,
                      0,
                      "",
                    );
                  }}
                >
                  エントリー
                </PoButton>
                <PoButton
                  variant="primary"
                  data-testid="contract-copy-entry-method-outside"
                  style={{
                    marginTop: "10px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: "10px",
                  }}
                  onClick={async () => {
                    if (addData.site_path_list.length === 1) {
                      await getProductInfo(
                        addData.productId as number,
                        addData.productName,
                        1,
                        addData.site_path_list[0],
                      );
                    } else {
                      setAddData((addData) => ({
                        ...addData,
                        addStatus: "site_path",
                      }));
                    }
                  }}
                >
                  外部URL作成
                </PoButton>
              </Box>
            </Box>
          </Paper>
        ) : addData.addStatus === "site_path" ? (
          // cmd-po_1147: Typography退役・footer→PoModalShell footer へ
          <Paper elevation={0}>
            <Box key="contract1_site_path">
              <Box
                key="shozaiClick_site_path"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {addData.site_path_list.map((site_path, i) => {
                  return (
                    <PoButton
                      key={i}
                      variant="primary"
                      style={{
                        marginTop: "10px",
                        width:
                          windowWidth > 385
                            ? "calc(50% - 5px)"
                            : "calc(100% - 10px)",
                        marginLeft:
                          windowWidth > 385 && i % 2 !== 0 ? "10px" : "0",
                      }}
                      onClick={async () => {
                        await getProductInfo(
                          addData.productId as number,
                          addData.productName,
                          1,
                          site_path,
                        );
                      }}
                    >
                      {site_path}
                    </PoButton>
                  );
                })}
              </Box>
            </Box>
          </Paper>
        ) : addData.addStatus === "contract" ? (
          // cmd-po_1147: Typography退役・footer→PoModalShell footer へ
          <Paper elevation={0}>
              <Box
                key="contract1"
                sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
              >
                <Box data-testid="contract-copy-entry-selected-product-row" sx={{ display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>
                  <Box component="span" data-testid="contract-copy-entry-selected-product-label" sx={{ fontSize: "var(--fs-11, 11px)", color: "var(--color-sumi-muted, #6b7280)" }}>商材</Box>
                  <Box data-testid="contract-copy-entry-selected-product" className="sel-prod-chip" sx={{ display: "inline-flex", alignItems: "center", gap: "var(--sp-2, 8px)", fontSize: "var(--fs-12, 12px)", color: "var(--color-ai, #1e3a5f)", bgcolor: "var(--color-ai-pale, #e8eef4)", borderRadius: "var(--radius-sm, 6px)", padding: "var(--px-3, 3px) var(--px-10, 10px)", fontWeight: "var(--fw-semibold, 600)" }}>
                    {addData.productName as string}
                  </Box>
                </Box>
                {addData.outSiteEntry === 0 ? (
                  <>
                    <PoField fieldKey="servicePlanName">
                      <PoLabel required>プラン</PoLabel>
                      <PoSelect
                        key={"servicePlanSelect"}
                        value={addData.servicePlanName}
                        onChange={(e) => {
                          const servicePlanName = e.target.value as string;
                          setAddData((addData) => ({
                            ...addData,
                            servicePlanName,
                          }));
                        }}
                        fullWidth
                      >
                        {selectServisePlanList.map((service, plan_i) => {
                          return (
                            <MenuItem
                              key={"tableColumnKomokuPlan" + plan_i}
                              value={service.service_name}
                              sx={{
                                fontSize: "14px",
                                height:
                                  service.service_name === ""
                                    ? "14px"
                                    : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {service.service_name}
                            </MenuItem>
                          );
                        })}
                      </PoSelect>
                    </PoField>
                    {selectServiseContentList.length > 0 ? (
                      <PoField key="contractServiceContent" fieldKey="serviceContentNameList">
                        <PoLabel>コンテンツ</PoLabel>
                        <PoCheckGroup>
                          {selectServiseContentList.map((service, si) => (
                            <PoCheckRow key={"serviceContent_" + si}>
                              <PoCheckbox
                                checked={
                                  addData.serviceContentNameList.findIndex(
                                    (serviceName) =>
                                      serviceName === service.service_name,
                                  ) > -1
                                }
                                onClick={() => {
                                  let serviceContentNameList =
                                    addData.serviceContentNameList.concat();
                                  if (
                                    addData.serviceContentNameList.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  ) {
                                    serviceContentNameList =
                                      serviceContentNameList.filter(
                                        (serviceName) =>
                                          serviceName !== service.service_name,
                                      );
                                  } else {
                                    serviceContentNameList.push(
                                      service.service_name,
                                    );
                                  }
                                  setAddData((addData) => ({
                                    ...addData,
                                    serviceContentNameList,
                                  }));
                                }}
                              />
                              {service.service_name}
                            </PoCheckRow>
                          ))}
                        </PoCheckGroup>
                      </PoField>
                    ) : null}
                    {selectServiseCampaignPulldownList.length > 0 ? (
                      <PoField key="serviceeCampaignPulldownLabelBox" fieldKey="serviceCampaignPulldownName">
                        <PoLabel>
                          {selectServiseCampaignCheckboxList.length > 0
                            ? "キャンペーン1"
                            : "キャンペーン"}
                        </PoLabel>
                        <PoSelect
                          key={"serviceCampaignPulldownSelect"}
                          value={addData.serviceCampaignPulldownName}
                          onChange={(e) => {
                            const serviceCampaignPulldownName = e.target
                              .value as string;
                            setAddData((addData) => ({
                              ...addData,
                              serviceCampaignPulldownName,
                            }));
                          }}
                          fullWidth
                        >
                          {selectServiseCampaignPulldownList.map(
                            (service, plan_i) => {
                              return (
                                <MenuItem
                                  key={
                                    "tableColumnKomokuCampaignPulldown" +
                                    plan_i
                                  }
                                  value={service.service_name}
                                  sx={{
                                    fontSize: "14px",
                                    height:
                                      service.service_name === ""
                                        ? "14px"
                                        : "24px",
                                    minHeight: "auto",
                                  }}
                                >
                                  {service.service_name}
                                </MenuItem>
                              );
                            },
                          )}
                        </PoSelect>
                      </PoField>
                    ) : null}
                    {selectServiseCampaignCheckboxList.length > 0 ? (
                      <PoField key="contractServiceCampaignCheckbox" fieldKey="serviceCampaignCheckboxName">
                        <PoLabel>
                          {selectServiseCampaignPulldownList.length > 0
                            ? "キャンペーン2"
                            : "キャンペーン"}
                        </PoLabel>
                        <PoCheckGroup>
                          {selectServiseCampaignCheckboxList.map((service, si) => (
                            <PoCheckRow key={"serviceCampaignCbx_" + si}>
                              <PoCheckbox
                                checked={
                                  addData.serviceCampaignCheckboxName.findIndex(
                                    (serviceName) =>
                                      serviceName === service.service_name,
                                  ) > -1
                                }
                                onClick={() => {
                                  let serviceCampaignCheckboxName =
                                    addData.serviceCampaignCheckboxName.concat();
                                  if (
                                    addData.serviceCampaignCheckboxName.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  ) {
                                    serviceCampaignCheckboxName =
                                      serviceCampaignCheckboxName.filter(
                                        (serviceName) =>
                                          serviceName !== service.service_name,
                                      );
                                  } else {
                                    serviceCampaignCheckboxName.push(
                                      service.service_name,
                                    );
                                  }
                                  setAddData((addData) => ({
                                    ...addData,
                                    serviceCampaignCheckboxName,
                                  }));
                                }}
                              />
                              {service.service_name}
                            </PoCheckRow>
                          ))}
                        </PoCheckGroup>
                      </PoField>
                    ) : null}
                    <PoField fieldKey="servicePaymentMethodName">
                      {selectServisePaymentList.length > 0 ? (
                        <PoLabel required>支払方法</PoLabel>
                      ) : (
                        <PoLabel optional>支払方法</PoLabel>
                      )}
                      {selectServisePaymentList.length > 0 ? (
                        <PoSelect
                          key={"servicePaymentSelect"}
                          value={addData.servicePaymentMethodName}
                          onChange={(e) => {
                            const servicePaymentMethodName = e.target
                              .value as string;
                            setAddData((addData) => ({
                              ...addData,
                              servicePaymentMethodName,
                            }));
                          }}
                          fullWidth
                        >
                          {selectServisePaymentList.map((payment, plan_i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + plan_i}
                                value={payment.payment_method}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    payment.payment_method === ""
                                      ? "14px"
                                      : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {payment.payment_method}
                              </MenuItem>
                            );
                          })}
                        </PoSelect>
                      ) : (
                        <PoTextField
                          id="textFieldIdPaymentMethod"
                          fullWidth
                          value={addData.servicePaymentMethodName}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              servicePaymentMethodName: e.target.value,
                            }));
                          }}
                        />
                      )}
                    </PoField>
                  </>
                ) : addData.outSiteEntry === 1 ? (
                  <>
                    <PoField key="outsideMessageType" fieldKey="outsideMessageType">
                      <PoLabel required>外部URL共有方法</PoLabel>
                      <PoSelect
                        key={"outsideMessageTypeID"}
                        value={addData.outsideMessageType}
                        onChange={(e) => {
                          const outsideMessageType = e.target
                            .value as number;
                          setAddData((addData) => ({
                            ...addData,
                            smsMessagePatternID: null,
                            outsideMessageType,
                          }));
                        }}
                        fullWidth
                      >
                        {smsMessagePatterns.length > 0 ? (
                          <MenuItem
                            key={"outsideMessageTypeID_1"}
                            value={0}
                            sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                          >
                            SMS送信
                          </MenuItem>
                        ) : null}
                        {mailMessagePatterns.length > 0 ? (
                          <MenuItem
                            key={"outsideMessageTypeID_2"}
                            value={1}
                            sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                          >
                            メール送信
                          </MenuItem>
                        ) : null}
                        <MenuItem
                          key={"outsideMessageTypeID_3"}
                          value={2}
                          sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                        >
                          QRコード表示
                        </MenuItem>
                      </PoSelect>
                    </PoField>
                    {addData.outsideMessageType === 0 ? (
                      <>
                        <PoField key="smsMessagePatternsBox" fieldKey="smsMessagePatternID">
                          <PoLabel required>SMSメッセージ選択</PoLabel>
                          <PoSelect
                            key={"smsMessagePatternID"}
                            value={addData.smsMessagePatternID}
                            onChange={(e) => {
                              const smsMessagePatternID = e.target
                                .value as number;
                              setAddData((addData) => ({
                                ...addData,
                                smsMessagePatternID,
                              }));
                            }}
                            fullWidth
                          >
                            {smsMessagePatterns.map((message, message_i) => (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + message_i}
                                value={message.id}
                                sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                              >
                                {message.outside_sms_name}
                              </MenuItem>
                            ))}
                          </PoSelect>
                        </PoField>
                        {smsMessagePatterns.map((message) => {
                          if (message.id === addData.smsMessagePatternID) {
                            return (
                              <Box key="smsMessageSampleBox">
                                <PoField fieldKey="sms_sender">
                                  <PoLabel>SMSメッセージ-送信ID</PoLabel>
                                  <PoTextField
                                    disabled
                                    fullWidth
                                    value={message.outside_sms_sender}
                                  />
                                </PoField>
                                <PoField fieldKey="sms_body">
                                  <PoLabel>SMSメッセージ-サンプル</PoLabel>
                                  <PoTextField
                                    disabled
                                    fullWidth
                                    value={message.outside_sms_body}
                                    multiline
                                    rows={5}
                                  />
                                </PoField>
                              </Box>
                            );
                          }
                        })}
                      </>
                    ) : addData.outsideMessageType === 1 ? (
                      <>
                        <PoField key="mailMessagePatternsBox" fieldKey="mailMessagePatternID">
                          <PoLabel required>メール選択</PoLabel>
                          <PoSelect
                            key={"mailMessagePatternID"}
                            value={addData.smsMessagePatternID}
                            onChange={(e) => {
                              const smsMessagePatternID = e.target
                                .value as number;
                              setAddData((addData) => ({
                                ...addData,
                                smsMessagePatternID,
                              }));
                            }}
                            fullWidth
                          >
                            {mailMessagePatterns.map((message, message_i) => (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + message_i}
                                value={message.id}
                                sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                              >
                                {message.outside_sms_name}
                              </MenuItem>
                            ))}
                          </PoSelect>
                        </PoField>
                        {mailMessagePatterns.map((message) => {
                          if (message.id === addData.smsMessagePatternID) {
                            return (
                              <Box key="mailMessageSampleBox">
                                <PoField fieldKey="mail_sender">
                                  <PoLabel>メール-送信メールアドレス</PoLabel>
                                  <PoTextField disabled fullWidth value={message.outside_sms_sender} />
                                </PoField>
                                <PoField fieldKey="mail_title">
                                  <PoLabel>メール-タイトル</PoLabel>
                                  <PoTextField disabled fullWidth value={message.outside_sms_title} />
                                </PoField>
                                <PoField fieldKey="mail_body">
                                  <PoLabel>メール-本文</PoLabel>
                                  <PoTextField disabled fullWidth value={message.outside_sms_body} multiline rows={5} />
                                </PoField>
                              </Box>
                            );
                          }
                        })}
                      </>
                    ) : null}
                    {outSidePullDownServiceNameList.length > 0 ? (
                      <PoField key="pullDowmServiceName" fieldKey="pullDownServiceName">
                        <PoLabel required>サービス（プルダウン）</PoLabel>
                        <PoSelect
                          key={"pullDowmServiceNameID"}
                          value={addData.pullDownServiceName}
                          onChange={(e) => {
                            const pullDownServiceName = e.target
                              .value as string;
                            setAddData((addData) => ({
                              ...addData,
                              pullDownServiceName,
                            }));
                          }}
                          fullWidth
                        >
                          {outSidePullDownServiceNameList.map((service, i) => (
                            <MenuItem
                              key={"pullDowmServiceNameID_" + i}
                              value={service.service_name}
                              sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                            >
                              {service.service_name}
                            </MenuItem>
                          ))}
                        </PoSelect>
                      </PoField>
                    ) : null}
                    {outSideCheckBoxServiceNameList.length > 0 ? (
                      <PoField key="contractServiceCheckbox" fieldKey="checkBoxServiceNames">
                        <PoLabel>サービス（チェックボックス）</PoLabel>
                        <PoCheckGroup>
                          {outSideCheckBoxServiceNameList.map((service, si) => (
                            <PoCheckRow key={"outsideCheckbox_" + si}>
                              <PoCheckbox
                                checked={addData.checkBoxServiceNames
                                  .split(",")
                                  .includes(service.service_name)}
                                onClick={() => {
                                  let checkBoxServiceNamesArray =
                                    addData.checkBoxServiceNames.split(",");
                                  if (
                                    checkBoxServiceNamesArray.includes(
                                      service.service_name,
                                    )
                                  ) {
                                    checkBoxServiceNamesArray =
                                      checkBoxServiceNamesArray.filter(
                                        (_serviceName) =>
                                          _serviceName !== service.service_name,
                                      );
                                  } else {
                                    checkBoxServiceNamesArray.push(
                                      service.service_name,
                                    );
                                  }
                                  const checkBoxServiceNames =
                                    checkBoxServiceNamesArray.join(",");
                                  setAddData((addData) => ({
                                    ...addData,
                                    checkBoxServiceNames,
                                  }));
                                }}
                              />
                              {service.service_name}
                            </PoCheckRow>
                          ))}
                        </PoCheckGroup>
                      </PoField>
                    ) : null}
                  </>
                ) : null}

                <PoField fieldKey="serviseCustomerListID">
                  <PoLabel optional>リストID</PoLabel>
                  <PoTextField
                    id="textFieldIdListID"
                    fullWidth
                    value={addData.serviseCustomerListID}
                    onChange={async (e) => {
                      setAddData((addData) => ({
                        ...addData,
                        serviseCustomerListID: e.target.value,
                      }));
                    }}
                  />
                </PoField>
                {addData.outSiteEntry === 1 &&
                addData.outsideMessageType === 1 &&
                useMailAddressFlg === false ? (
                  <PoField fieldKey="mail_address_for_send">
                    <PoLabel required>メールアドレス（メール送信用）</PoLabel>
                    <InputFreeTextMailAddress
                      addData={addData}
                      setAddData={setAddData}
                      uniqueOption={{
                        option_name: "メールアドレス",
                      }}
                      addressOptionName={addressOptionName}
                    />
                  </PoField>
                ) : null}
                {uniqueOptinList.map((uniqueOption, option_i) => {
                  const option_selects = uniqueOption.option_select as string[];
                  let option_view = false;
                  if (addData.outSiteEntry == 0) {
                    const service_plan_names =
                      (uniqueOption.service_plan_names as string[]) || [];
                    const service_content_names =
                      (uniqueOption.service_content_names as string[]) || [];
                    const depend_option_name =
                      (uniqueOption.depend_option_name as string) ||
                      "他質問に依存しない";
                    const depend_select_names =
                      (uniqueOption.depend_select_names as string[]) || [];
                    const depend_option_value =
                      addData.customerInfo[depend_option_name];
                    option_view =
                      (service_plan_names.length === 0 ||
                        service_plan_names.includes(addData.servicePlanName)) &&
                      (service_content_names.length === 0 ||
                        service_content_names.some((item) =>
                          addData.serviceContentNameList.includes(item),
                        )) &&
                      (depend_option_name === "他質問に依存しない" ||
                        (typeof depend_option_value === "string" &&
                          depend_select_names.includes(
                            depend_option_value as string,
                          )) ||
                        (typeof depend_option_value === "object" &&
                          depend_select_names.some((item) =>
                            depend_option_value.includes(item),
                          )));
                  } else if (addData.outSiteEntry == 1) {
                    option_view = true;
                  }
                  if (option_view) {
                    return (
                      <PoField key={"optionBox_" + option_i} fieldKey={uniqueOption.option_name as string}>
                        <PoLabel
                          required={
                            addData.outSiteEntry === 0
                              ? uniqueOption.required_optional === 1
                              : addData.outSiteEntry === 1
                                ? (addData.outsideMessageType === 0 && uniqueOption.tel_flg === 1) ||
                                  (addData.outsideMessageType === 1 && uniqueOption.mail_address_flg === 1)
                                : false
                          }
                          optional={
                            addData.outSiteEntry === 0
                              ? uniqueOption.required_optional !== 1
                              : false
                          }
                          note={
                            addData.outSiteEntry === 1 &&
                            !((addData.outsideMessageType === 0 && uniqueOption.tel_flg === 1) ||
                              (addData.outsideMessageType === 1 && uniqueOption.mail_address_flg === 1)) &&
                            uniqueOption.outside_form_display === 1
                              ? "外部ET非表示"
                              : undefined
                          }
                        >
                          {uniqueOption.option_name}
                        </PoLabel>
                        {uniqueOption.option_type === 0 ? (
                          uniqueOption.tel_flg === 1 ? (
                            <InputFreeTextTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.name_flg === 1 ? (
                            <InputFreeTextName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.company_name_flg === 1 ? (
                            <InputFreeTextCompanyName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.zip_code_flg === 1 ? (
                            <InputFreeTextZipCode
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.space_flg === 1 ? (
                            <InputFreeTextSpace
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.mail_address_flg === 1 ? (
                            <InputFreeTextMailAddress
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.form_tel_flg === 1 ? (
                            <InputFreeTextFormTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (uniqueOption.half_width_number_flg || 0) ===
                            1 ? (
                            <InputFreeTextHalfWidthNumber
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (
                            <InputFreeText
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          )
                        ) : uniqueOption.option_type === 1 ? (
                          <>
                            <PoSelect
                              key={"tableColumnKomokuDataSelect" + option_i}
                              fullWidth
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={(e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value as string;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                            >
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuMenuItem" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                      value={option_select}
                                      sx={{
                                        fontSize: "14px",
                                        height:
                                          option_select === ""
                                            ? "14px"
                                            : "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {option_select}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </PoSelect>
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 2 ? (
                          <>
                            <PoCheckGroup>
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  const customerInfoList = addData.customerInfo[
                                    uniqueOption.option_name as string
                                  ] as string[];
                                  return (
                                    <PoCheckRow
                                      key={
                                        "tableColumnKomokuDataBox" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                    >
                                      <PoCheckbox
                                        checked={
                                          customerInfoList.findIndex(
                                            (_option_select) =>
                                              _option_select === option_select,
                                          ) > -1
                                        }
                                        onClick={() => {
                                          let _customerInfoList =
                                            customerInfoList.concat();
                                          if (
                                            customerInfoList.findIndex(
                                              (_option_select) =>
                                                _option_select === option_select,
                                            ) > -1
                                          ) {
                                            _customerInfoList =
                                              _customerInfoList.filter(
                                                (_option_select) =>
                                                  _option_select !==
                                                  option_select,
                                              );
                                          } else {
                                            _customerInfoList.push(option_select);
                                          }
                                          let customerInfo = addData.customerInfo;
                                          customerInfo[
                                            uniqueOption.option_name as string
                                          ] = _customerInfoList;
                                          setAddData((addData) => ({
                                            ...addData,
                                            customerInfo,
                                          }));
                                        }}
                                      />
                                      {option_select}
                                    </PoCheckRow>
                                  );
                                },
                              )}
                            </PoCheckGroup>
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 3 ? (
                          <>
                            <PoTextField
                              id="textFieldIdDate"
                              fullWidth
                              type="date"
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={async (e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                            />
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 4 ? (
                          <PoFileDrop
                            inputProps={{
                              id: "textFieldPicture",
                              onChange: (
                                event_file: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                if (
                                  event_file.target.files &&
                                  event_file.target.files.length > 0
                                ) {
                                  const file = event_file.target.files[0];
                                  const updatedPostPictures = {
                                    ...postPictures,
                                    [uniqueOption.option_name as string]: file,
                                  };
                                  setPostPictures(updatedPostPictures);
                                }
                              },
                            }}
                            error={postPicturesError[uniqueOption.option_name as string]}
                            onClear={() => {
                              const updated = { ...postPictures };
                              delete updated[uniqueOption.option_name as string];
                              setPostPictures(updated);
                              setPostPicturesError({ ...postPicturesError, [uniqueOption.option_name as string]: "" });
                            }}
                          />
                        ) : null}
                      </PoField>
                    );
                  }
                })}
              </Box>
            </Paper>
        ) : addData.addStatus === "sms_success" ? (
          // cmd-po_1147: Typography退役・footer→PoModalShell footer へ
          <>
            <Paper elevation={0}>
                <Box key="shozai1">
                  <Box
                    
                    key="sms_success"
                    sx={{ marginTop: "15px", marginBottom: "5px" }}
                  >
                    {addData.outsideMessageType === 0
                      ? "SMSを送信しました。"
                      : addData.outsideMessageType === 1
                        ? "メールを送信しました。"
                        : addData.outsideMessageType === 2
                          ? "QRコードを表示します。"
                          : ""}
                  </Box>
                  <Box
                    
                    key="sms_success"
                    sx={{
                      marginTop: "25px",
                      marginBottom: "5px",
                      textAlign: "center",
                      display: windowWidth > 500 ? "flex" : undefined,
                    }}
                  >
                    <Box
                      sx={{
                        textAlign: "center",
                        width:
                          windowWidth > 385
                            ? 200
                            : windowWidth > 250
                              ? 180
                              : 140,
                        marginLeft:
                          addData.viewOutsideServiceUrl === 1
                            ? windowWidth > 500
                              ? "calc(50% - 210px - 2.5%)"
                              : "auto"
                            : "auto",
                        marginRight:
                          addData.viewOutsideServiceUrl === 1
                            ? windowWidth > 500
                              ? undefined
                              : "auto"
                            : "auto",
                      }}
                    >
                      <Box>
                        エントリーページ
                        <IconButton
                          sx={{
                            height: "25px",
                            width: "25px",
                            marginBottom: "5px",
                          }}
                          aria-label="detail row"
                          size="medium"
                          onClick={() => {
                            const canvas = document.querySelector("canvas");
                            const link = document.createElement("a");
                            if (canvas) {
                              link.href = canvas.toDataURL("image/png");
                              link.download = "qrcode.png";
                              link.click();
                            }
                          }}
                        >
                          <FileDownloadIcon fontSize="medium" />
                        </IconButton>
                      </Box>
                      <Box>
                        <QRCodeCanvas
                          value={addData.outsideSiteUrl}
                          size={
                            windowWidth > 385
                              ? 200
                              : windowWidth > 250
                                ? 180
                                : 140
                          }
                        />
                      </Box>
                    </Box>
                    {addData.viewOutsideServiceUrl === 1 ? (
                      <Box
                        sx={{
                          textAlign: "center",
                          width:
                            windowWidth > 385
                              ? 200
                              : windowWidth > 250
                                ? 180
                                : 140,
                          marginLeft:
                            windowWidth > 500 ? "calc(10px + 5%)" : "auto",
                          marginRight: windowWidth > 500 ? undefined : "auto",
                          marginTop: windowWidth > 500 ? undefined : "25px",
                        }}
                      >
                        <Box>
                          サービスページ
                          <IconButton
                            sx={{
                              height: "25px",
                              width: "25px",
                              marginBottom: "5px",
                            }}
                            aria-label="detail row"
                            size="medium"
                            onClick={() => {
                              const canvas = document.querySelector("canvas");
                              const link = document.createElement("a");
                              if (canvas) {
                                link.href = canvas.toDataURL("image/png");
                                link.download = "qrcode.png";
                                link.click();
                              }
                            }}
                          >
                            <FileDownloadIcon fontSize="medium" />
                          </IconButton>
                        </Box>
                        <Box>
                          <QRCodeCanvas
                            value={addData.outsideServiceUrl}
                            size={
                              windowWidth > 385
                                ? 200
                                : windowWidth > 250
                                  ? 180
                                  : 140
                            }
                          />
                        </Box>
                      </Box>
                    ) : null}
                  </Box>
                  <Box
                    
                    key="sms_success"
                    sx={{
                      marginTop: "45px",
                      marginBottom: "5px",
                      wordWrap: "break-word",
                      wordBreak: "break-all",
                    }}
                  >
                    エントリーページ: <br />
                    {addData.outsideSiteUrl}
                  </Box>
                  {addData.viewOutsideServiceUrl === 1 ? (
                    <Box
                      
                      key="sms_success"
                      sx={{
                        marginTop: "30px",
                        marginBottom: "5px",
                        wordWrap: "break-word",
                        wordBreak: "break-all",
                      }}
                    >
                      サービスページ: <br />
                      {addData.outsideServiceUrl}
                    </Box>
                  ) : null}
                </Box>
              </Paper>
          </>
        ) : null}
    </PoModalShell>
  ) : null;
}
